'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);

var BackdropContainer = styled__default.div.withConfig({
  displayName: "backdropstyle__BackdropContainer",
  componentId: "sc-1vpcktu-0"
})(["background-color:", ";bottom:0;left:0;position:fixed;right:0;top:0;z-index:-1;-webkit-tap-highlight-color:transparent;"], function (_ref) {
  var invisible = _ref.invisible;
  return invisible ? 'transparent' : 'rgba(0, 0, 0, 0.85)';
});

exports.BackdropContainer = BackdropContainer;
